import { fromJS } from 'immutable'

const initialState = fromJS({
  editing: false,
  contentType: '',
  content: '',
  nameField: ''
})

const appcontent = (state = initialState, action) => {

  switch (action.type) {
    case "SET_EDITING":
      return state.merge({
        editing: action.payload.editing,
        contentType: action.payload.contentType,
        content: action.payload.content,
        nameField: action.payload.nameField
      })
    case "SET_FORM":
      return state.merge({
        type: 'form',
        formid: action.payload
      })
    default:
      return state
  }
}

export default appcontent